import { captureException, captureMessage } from "@sentry/nextjs";

type AppMessageType =
	| {
			action: "share";
			data: {
				title: string;
				text: string;
				url: string;
			};
	  }
	| {
			action: "email";
			data: {
				email: string;
				subject?: string;
				body?: string;
			};
	  }
	| {
			action: "navigate";
			data: {
				path: string;
				allowBack?: boolean;
			};
	  }
	| {
			action: "go-back";
	  }
	| {
			action: "go-to-home";
	  }
	| {
			action: "open-in-webview";
			data: {
				url: string;
			};
	  }
	| {
			action: "open-in-browser";
			data: {
				url: string;
				external?: boolean;
			};
	  }
	| {
			action: "go-to-whatsapp";
			data: {
				text: string;
			};
	  }
	| {
			action: "open-ratings-popup";
	  }
	| {
			action: "go-to-passbook-export";
	  };

/**
 * This function helps to send data to flutter mobile app in webview
 * @param message
 * @param onFailure
 */

export function sendToApp(message: AppMessageType, onFailure?: () => void) {
	//@ts-ignore
	if (window.flutter_inappwebview) {
		//@ts-ignore
		window.flutter_inappwebview
			.callHandler("saltActionHandler", message)
			.then(() => {})
			.catch((e: any) => {
				captureException(e);
			});
	} else {
		if (onFailure) onFailure();
		captureMessage("flutter_inappwebview unavailable in window object");
	}
}

/**
 * This function helps to send data to native app in webview
 * window.JSBridge is for Android
 * window.webkit is for IOS
 * @param message
 * @param onFailure
 */
export function sendToSUDNativeApp(message: {
	cohortTitle: string;
	cohortIconUrl: string;
	resultId: string;
	resultPageUrl: string;
}) {
	try {
		const stringfyMessage = JSON.stringify(message);
		//@ts-ignore
		if (window.JSBridge && window.JSBridge?.showMessageInNative) {
			//@ts-ignore
			window.JSBridge?.showMessageInNative(stringfyMessage);
		} //@ts-ignore
		else if (window.webkit?.messageHandlers?.jsMessageHandler?.postMessage) {
			//@ts-ignore
			window.webkit.messageHandlers.jsMessageHandler.postMessage(
				stringfyMessage
			);
		} else {
			captureException(
				new Error(
					"window.JSBridge and window.webkit?.messageHandlers not found"
				)
			);
		}
	} catch (err) {
		captureException(err);
	}
}
